export const ENV_DEPLOY = "deploy";
export const ENV_STAGING = "staging";
export const ENV_LOCAL = "local";
export const ENV_DEMO = "demo";
